// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Int64LookupModel from '../../model/int64-lookup-model';
import Int64LookupDTO from '../dto/int64-lookup-dto';
import dtoSchema from '../schemas/int64-lookup-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class Int64LookupModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Int64LookupDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.caption = data.caption ?? undefined;
      this.details = data.details ?? undefined;
      this.sort = data.sort;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  caption?: string;
  /**
  */
  details?: string;
  /**
  * @type {int32}
  */
  sort?: number;

  static toModel(dto: DeepPartial<Int64LookupDTO>): Int64LookupModel;
  static toModel(dto: DeepPartial<Int64LookupDTO> | undefined | null): Int64LookupModel | undefined;
  static toModel(dto: DeepPartial<Int64LookupDTO> | undefined | null): Int64LookupModel | undefined {
    return dto ? new Int64LookupModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Int64LookupModel> | Int64LookupModel): Int64LookupDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      caption: unwrapped.caption,
      details: unwrapped.details,
      sort: unwrapped.sort,
    } as Int64LookupDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Int64LookupModel, can not map to Int64LookupDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
